import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import OrderItem from "./OrderItem";
import AddOrderItem from "./AddOrderItem";
import { cloneDeep, concat, filter, map as _map, isString, isArray } from 'lodash';

export default function OrderItemsCard({
    type,
    orderItems,
    validationErrors,
    handleChange,
    cardTitle = "Order Items"
}) {
    const { t } = useTranslation()
    const handleAddItem = item => {
        const newItem = { _id: `${item.count}*${item.description}`, item: item.description, amount: item.count };
        const oldItems = cloneDeep(orderItems) || [];
        const newItems = concat(oldItems, newItem);
        handleChange({
            target: {
                name: 'orderItems',
                value: newItems
            }
        })
    }

    const handleRemoveItem = id => {
        const newItems = filter(orderItems, item => item._id !== id)
        handleChange({
            target: {
                name: 'orderItems',
                value: newItems
            }
        })
    }
    return (
        <Card>
            <CardHeader title={t(cardTitle)} />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        {
                            !!orderItems?.length
                            &&
                            _map(
                                orderItems,
                                item => <OrderItem key={item._id} item={item} handleRemove={handleRemoveItem} deletable={type === "add"} />
                            )
                        }
                        {
                            (!orderItems?.length && type !== "add") &&
                            <Typography fontSize={16} color='text.dark'>{t("Order items not available")}</Typography>
                        }
                    </Grid>
                    {
                        type === "add" &&
                        <Grid item xs={12}>
                            {
                                !!orderItems &&
                                <Box>
                                    <Divider />
                                    <Typography variant='h5' sx={{ mt: 2 }}>{t("Add More Items")}</Typography>
                                </Box>
                            }
                            <AddOrderItem mt={2} handleAdd={handleAddItem} />
                        </Grid>
                    }
                    {
                        !!validationErrors?.orderItems &&
                        <Grid item xs={12}>
                            {isString(validationErrors?.orderItems) && <Typography fontSize={12} color='text.danger'>{t(validationErrors.orderItems)}</Typography>}
                            {isArray(validationErrors?.orderItems) &&
                                <Box>
                                    {
                                        _map(validationErrors.orderItems, (error, index) => (
                                            <Box key={index}>
                                                {Object.values(error).map((errMsg, errIndex) => (
                                                    <Typography key={errIndex} fontSize={12} color='text.danger'>{t(errMsg)}</Typography>
                                                ))}
                                            </Box>
                                        ))
                                    }
                                </Box>
                            }
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}